// monitor-card.component.ts
import { Component, OnInit, OnDestroy, ElementRef, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, Subscription } from 'rxjs';
import { EventBusService } from '../../../core/services/event-bus.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationService } from '../../../core/services/organization.service';
import { DetailsModalComponent } from '../organization/details-modal/details-modal.component';
import { ResponseModalComponent } from '../response-modal/response-modal.component';
import * as L from 'leaflet';
import { OrganizationUtilService } from '../../../core/services/organization-util.service';
import { ConfigurationManagerService } from '../../../core/services/configuration-manager.service';
import _ from 'lodash';
import { IncidentCategoryService } from '../../../core/services/incident-category.service';
import { PinActivationDialogComponent } from '../pin-activation-dialog/pin-activation-dialog.component';
import { SessionOptionsService } from '../../../core/services/session-option.service';
import { ArcAngelLiveModeService } from '../../../core/services/arc-angel-live-mode.service';
import { ArcAngelMonitorModeService } from '../arc-angel-monitor-mode.service';
import { IllumLiveService } from '../../../core/services/illum-live.service';
import moment from 'moment';
import { AlertService } from '../../../core/services/alert.service';

@Component({
  selector: 'app-monitor-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './monitor-card.component.html',
  styleUrl: './monitor-card.component.css'
})
export class MonitorCardComponent implements OnInit, OnDestroy {
  message: any;
  title: string = '';
  alertInfo: any; // Added to fix the error
  building: string = '';
  floor: string = '';
  room: string = '';
  description: string = '';
  time: string = '';
  name: string = '';
  number: string = '';
  suspectPhoneNumber: string = '';
  suspectDetails: string = '';
  sopInfo: any = '';
  sopname: string = '';
  datetime: string = '';

  org: any; // Make sure this is a public property
  userInfo: any; // Added to fix the error
  activeTab: string = 'basic';
  suspectCheckedOnInit: boolean = false;
  floorMap: L.Map | null = null;
  cameraIcon: any;
  accessControlIcon: any;
  private pulsatingCircle: L.CircleMarker | null = null;
  private pulsatingCircleRadius: number = 0;
  private pulsatingTimeout: any = null;
  cameraListForFloor: any[] = [];
  accessControlListForFloor: any[] = [];

  @Output() close = new EventEmitter<void>();
  @Output() openPinDialog = new EventEmitter<any>();

  // setTab(tab: string) {
  //   this.activeTab = tab;
  // }
  constructor(
    public activeModal: NgbActiveModal,
    private organizationService: OrganizationService,
    private modalService: NgbModal,
    private orgutils: OrganizationUtilService,
    private incidentCategoryService: IncidentCategoryService,
    private sessionOptionsService: SessionOptionsService,
    private arcAngelLiveModeService: ArcAngelLiveModeService,
    private arcAngelMonitorModeService: ArcAngelMonitorModeService,
    private illumliveservice: IllumLiveService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    const buildingInfo = this.alertInfo?.buildingInfo?.[0];
    const alertRow = this.alertInfo?.alertPayload?.rows?.[0];
    const user = this.alertInfo?.userDetails;
    this.userInfo = user;
    this.sopInfo = this.alertInfo?.sopDetails?.rows?.[0];
    this.building = buildingInfo?.building?.label || 'NA';
    this.floor = buildingInfo?.floor?.label || 'NA';
    this.room = buildingInfo?.room?.label || 'NA';
    const payloadDescription = String(alertRow?.description || this.alertInfo?.description || '').trim();
    this.description = payloadDescription || this.alertInfo?.name || '';
    const timeSource = this.alertInfo?.occuredAt || this.alertInfo?.createdAt || alertRow?.createdAt;
    this.time = timeSource ? moment(timeSource).format('DD/MM/YYYY HH:mm:ss') : '';
    this.name = user?.name || '';
    this.number = user?.UserPhones?.[0]?.number || '';
    this.sopname = this.sopInfo?.label || '';
    this.datetime = this.sopInfo?.createdAt || '';

    if (this.number && !this.suspectCheckedOnInit) {
      this.checkSuspect(this.number, true, false);
      this.suspectCheckedOnInit = false;
    }
  }

  ngAfterViewInit(): void {
    if (this.activeTab === 'floor') {
      setTimeout(() => this.createFloorMap(), 0);
    }
  }

  setTab(tab: string) {
    this.activeTab = tab;
    if (tab === 'floor') {
      setTimeout(() => this.createFloorMap(), 0);
    }
  }

  createFloorMap(): void {
    if (this.floorMap) {
      this.floorMap.off();
      this.floorMap.remove();
      this.floorMap = null;
    }

    const floorPerimeterId = this.getFloorPerimeterId();
    if (!floorPerimeterId) return;

    const floorPerimeter = this.getFloorPerimeterById(floorPerimeterId);
    if (!floorPerimeter) return;

    const floorPlanRotationCoords = floorPerimeter.getFloorPlanRotationCoords();

    const lat = floorPerimeter.centerpoint.latitude;
    const lng = floorPerimeter.centerpoint.longitude;
    this.floorMap = L.map('floor-map-monitor-card', {
      zoomControl: true,
      attributionControl: true
    }).setView([lat, lng], 19);
    L.tileLayer(
      ConfigurationManagerService.configSettings.floorAttributeVisualizer
        .leaflet.tileLayer.url,
      ConfigurationManagerService.configSettings.floorAttributeVisualizer
        .leaflet.tileLayer.options
    )
      .setOpacity(0.2)
      .addTo(this.floorMap!);
    this.addPolygonToMap(floorPerimeter, floorPerimeter.name, this.floorMap);

    // 7. Highlight alert rooms
    const alertRoomPerimeterIds = (this.alertInfo?.buildingInfo || [])
      .map((o: any) => o.room?.arcAngelId ?? o.room?.id)
      .filter((id: any) => !!id);
    let perimeters: any[] = [];
    if (Array.isArray(floorPerimeter.perimeters)) {
      perimeters = floorPerimeter.perimeters;
    } else if (floorPerimeter.perimeters && typeof floorPerimeter.perimeters === 'object') {
      perimeters = Object.values(floorPerimeter.perimeters);
    }
    perimeters.forEach((p: any) => {
      const p1 = _.clone(p);
      if (alertRoomPerimeterIds.includes(p1.arcAngelId)) {
        p1.material = { red: 1, green: 0, blue: 0, alpha: 1 };
      }
      if (this.floorMap) {
        this.addPolygonToMap(p1, p.name, this.floorMap);
      }
    });

    this.getFloorplanFile(floorPerimeter.floorplanId).then((response: any) => {
      if (response && floorPlanRotationCoords?.length === 3) {
        const [point1, point2, point3] = floorPlanRotationCoords.map(this.flipCoords);
        const imgSrc = 'data:image/png;base64,' + this.arrayBufferToBase64(response.data);
        const overlay = (L as any).imageOverlay.rotated(imgSrc, point1, point2, point3, {
          opacity: 1.0
        });

        this.floorMap!.addLayer(overlay);
      }
      this.floorMap!.fitBounds(L.latLngBounds(floorPerimeter.locations));
      return this.organizationService.getSensorList();
    }).then((results$: Observable<any>) => {
      results$.subscribe((results) => {
        const buildingPerimeterId = floorPerimeter.building.perimeterId;
        const floorPerimeterId = floorPerimeter.perimeterId;

        const cameraListForFloor = this.getSensorListForFloor(
          buildingPerimeterId,
          floorPerimeterId,
          results.buildings,
          results.cameraList
        );

        cameraListForFloor.forEach((camera: any) => {
          const marker = L.marker([camera.position.coordinates[1], camera.position.coordinates[0]], { icon: this.cameraIcon });
          marker.addTo(this.floorMap!);
          marker.bindTooltip(camera.label);
          marker.on('click', () => this.viewCamera(camera));
        });

        const accessControlListForFloor = this.getSensorListForFloor(buildingPerimeterId, floorPerimeterId, results.buildings, results.accessControlList);
        accessControlListForFloor.forEach((sensor: any) => {
          const marker = L.marker([sensor.position.coordinates[1], sensor.position.coordinates[0]], { icon: this.accessControlIcon });
          marker.addTo(this.floorMap!);
          marker.bindTooltip(sensor.label);
        });
        this.centerAndZoom();
        this.startPulsatingCircle();
      });
    });
  }

  private getFloorPerimeterId(): string | null {
    const buildingInfo = this.alertInfo?.buildingInfo;
    if (Array.isArray(buildingInfo) && buildingInfo.length > 0) {
      const floor = buildingInfo[0]?.floor;
      if (floor && (floor.arcAngelId || floor.id)) {
        return floor.arcAngelId || floor.id;
      }
    }
    return null;
  }

  private getFloorPerimeterById(id: string): any {

    const perimeterAreaMap = this.orgutils.data?.perimeterAreaMap;
    if (perimeterAreaMap && id && perimeterAreaMap[id]) {
      return perimeterAreaMap[id];
    }
    return null;
  }
  addPolygonToMap(
    polygonData: any,
    polygonName: string,
    map: L.Map,
    date?: any
  ): L.Polygon {
    function rgbToHex(r: number, g: number, b: number): string {
      return (
        '#' +
        [r, g, b]
          .map((x) => {
            const hex = Math.round(x).toString(16);
            return hex.length === 1 ? '0' + hex : hex;
          })
          .join('')
      );
    }

    let outlineColor: string | undefined;
    let strokeWeight: number | undefined;

    if (polygonData.outlineColor) {
      outlineColor = rgbToHex(
        polygonData.outlineColor.red * 255,
        polygonData.outlineColor.green * 255,
        polygonData.outlineColor.blue * 255
      );
    }

    if (polygonData.outlineWidth) {
      strokeWeight = polygonData.outlineWidth;
    }

    const fillColor = rgbToHex(
      polygonData.material.red * 255,
      polygonData.material.green * 255,
      polygonData.material.blue * 255
    );
    let fillOpacity = polygonData.material.alpha;

    if (polygonData.layerPath === 'ArcAngel//Perimeters') {
      fillOpacity = 0.5;
    }

    const locations = polygonData.locations;

    const leafletPolygon = L.polygon(locations, {
      color: outlineColor,
      weight: strokeWeight,
      fillColor: fillColor,
      opacity: fillOpacity,
    });

    leafletPolygon.addTo(map).bindPopup(polygonName);
    (leafletPolygon as any).arcAngelUpdatedDate = date;

    return leafletPolygon;
  }
  private flipCoords(coord: [number, number]): [number, number] {
    return [coord[1], coord[0]];
  }
  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
  private getFloorplanFile(floorplanId: string): Promise<any> {
    return Promise.resolve(null);
  }

  private getSensorListForFloor(
    buildingPerimeterId: string,
    floorPerimeterId: string,
    buildings: any[],
    sensorList: any[]
  ): any[] {
    const building = buildings.find(
      (b: any) =>
        b.id &&
        buildingPerimeterId &&
        parseInt(b.id) === parseInt(buildingPerimeterId)
    );
    if (!building) return [];

    const floor = (building.floors || []).find(
      (f: any) => parseInt(f.id) === parseInt(floorPerimeterId)
    );
    if (!floor) return [];

    return sensorList.filter(
      (sensor: any) =>
        (Array.isArray(floor.descendants) && floor.descendants.includes(sensor.perimeterId)) ||
        sensor.perimeterId === floor.id
    );
  }
  private viewCamera(camera: any) {
  }
  private centerAndZoom(): void {
    const sensorId = this.alertInfo?.entity?.object?.sensorId;
    if (!sensorId) return;

    let sensors = this.accessControlListForFloor.filter((o: any) => o.id === sensorId);
    if (sensors.length === 0) {
      sensors = this.cameraListForFloor.filter((o: any) => o.id === sensorId);
    }

    if (sensors.length > 0 && this.floorMap) {
      const lat = sensors[0].position.coordinates[1];
      const lon = sensors[0].position.coordinates[0];
      this.floorMap.setView(new L.LatLng(lat, lon), 21);
    }
  }
  private startPulsatingCircle(): void {
    if (!this.floorMap || this.activeTab !== 'floor') {
      return;
    }

    let observationLat: number | undefined;
    let observationLon: number | undefined;
    let observationOnFloor = false;
    const alertObj = this.alertInfo?.entity?.object;
    if (alertObj?.observationId) {
      const features = (alertObj.AlertFeatures || []).filter(
        (o: any) => o.geometry?.type?.toLowerCase() === 'point'
      );
      if (features.length > 0) {
        observationLat = features[0].geometry.coordinates[1];
        observationLon = features[0].geometry.coordinates[0];
      }

      if (Array.isArray(alertObj.perimeterIds) && alertObj.perimeterIds.length > 0) {
        const observationPerimeterId = alertObj.perimeterIds[0];
        const buildingInfo = alertObj.buildingInfo?.[0];
        const floorPerimeterId = buildingInfo?.floor?.arcAngelId;
        const roomPerimeterId = buildingInfo?.room?.arcAngelId;
        if (
          observationPerimeterId &&
          floorPerimeterId &&
          observationPerimeterId.toString() === floorPerimeterId.toString()
        ) {
          observationOnFloor = true;
        }
        if (
          observationPerimeterId &&
          roomPerimeterId &&
          observationPerimeterId.toString() === roomPerimeterId.toString()
        ) {
          if (
            Array.isArray(buildingInfo?.room?.ancestors) &&
            buildingInfo.room.ancestors.includes(floorPerimeterId)
          ) {
            observationOnFloor = true;
          }
        }
      }
    }

    let sensorLat: number | undefined;
    let sensorLon: number | undefined;
    const sensorId = alertObj?.sensorId;
    let sensors = this.accessControlListForFloor.filter((o: any) => o.id === sensorId);
    if (sensors.length === 0) {
      sensors = this.cameraListForFloor.filter((o: any) => o.id === sensorId);
    }
    if (sensors.length > 0) {
      sensorLat = sensors[0].position.coordinates[1];
      sensorLon = sensors[0].position.coordinates[0];
    }

    let lat: number | undefined;
    let lon: number | undefined;
    if (observationLat && observationLon && observationOnFloor) {
      lat = observationLat;
      lon = observationLon;
    } else if (sensorLat && sensorLon) {
      lat = sensorLat;
      lon = sensorLon;
    }

    if (!lat || !lon) {
      return;
    }

    if (this.pulsatingCircle && this.floorMap) {
      this.floorMap.removeLayer(this.pulsatingCircle);
    }

    this.pulsatingCircleRadius += 4;
    if (this.pulsatingCircleRadius > 50) {
      this.pulsatingCircleRadius = 0;
    }

    this.pulsatingCircle = L.circleMarker([lat, lon], {
      radius: this.pulsatingCircleRadius,
      color: '#ff4444',
      weight: 4,
      fill: false
    }).bindTooltip('').addTo(this.floorMap!) as L.CircleMarker;

    this.pulsatingTimeout = setTimeout(() => this.startPulsatingCircle(), 200);
  }
  createIncident(buildingInfo: any): void {
    let perimeterId: string | null = null;
    let selectedFloorPerimeterId: string | null = null;
    let selectedRoomPerimeterId: string | null = null;

    if (buildingInfo) {
      perimeterId = buildingInfo.building?.id || null;
      selectedFloorPerimeterId = buildingInfo.floor?.id || null;
      selectedRoomPerimeterId = buildingInfo.room?.id || null;
    }

    if (!perimeterId) {
      return;
    }

    const alertId = this.alertInfo?.id;
    const orgId = this.orgutils.data?.myFirstOrg?.id;
    const incidentCategoryId = null;

    const incidentObj = {
      alertId: alertId,
      description: undefined,
      focalPoint: undefined,
      incidentCategoryId: incidentCategoryId || undefined,
      includeFloors: true,
      label: 'Label',
      orgId: orgId,
      perimeterId: perimeterId,
      selectedFloorPerimeterId: selectedFloorPerimeterId || undefined,
      selectedRoomPerimeterId: selectedRoomPerimeterId || undefined,
    };

    this.incidentCategoryService.createIncidentFromPerimeter(incidentObj).subscribe({
      next: (response) => {
        const modalRef = this.modalService.open(PinActivationDialogComponent, {
          size: 'lg',
          centered: true,
          backdrop: 'static',
          keyboard: false,
          windowClass: 'custom-modal',
        });

        modalRef.componentInstance.dialogData = response;

        modalRef.componentInstance.ngOnChanges({
          dialogData: {
            currentValue: response,
            previousValue: null,
            firstChange: true,
            isFirstChange: () => true,
          },
        });

        this.activeModal.close('Alert incident');
        modalRef.result
          .then((result) => {
             if (result === 'ACTIVATE_AND_GO') {
      this.incidentCategoryService.createIncidentAfterDialog().subscribe({
        next: (incidentId) => {
           const orgId = this.arcAngelMonitorModeService.getOrgIdForLiveIncident(incidentId ?? '');
          this.illumliveservice.setManagingOrgId(orgId ?? '0');
          this.incidentCategoryService.setManagingOrgId(orgId ?? '0');
            this.sessionOptionsService.goToLiveIncidentMode(incidentId ?? '', true, true);
            this.arcAngelLiveModeService.startLiveIncidentMode(incidentId ?? '', this);
        },
        error: (err) => {
          const errorMessage = this.extractErrorMessage(err);
          this.showAlert(errorMessage);
        },
      });
    }
          })
          .catch((error) => {
            console.error('Pin Activation Dialog dismissed with error:', error);
          });
      },
      error: (error) => {
        console.error('Failed to create active incident:', error);
        this.errorModal('Incident Creation Error', 'An error occurred while creating the incident.');
      },
    });
  }
  handleCardSelected(card: any): void {
  }

  ngOnDestroy(): void {
    if (this.floorMap) {
      this.floorMap.off();
      this.floorMap.remove();
      this.floorMap = null;
    }
    if (this.pulsatingTimeout) {
      clearTimeout(this.pulsatingTimeout);
      this.pulsatingTimeout = null;
    }
    if (this.pulsatingCircle && this.floorMap) {
      // this.floorMap.removeLayer(this.pulsatingCircle);
      this.pulsatingCircle = null;
    }
    // this.subscriptions.unsubscribe();
  }

  checkSuspect(number: string, isFromInit: boolean = false, state: boolean): void {
    if (!number || typeof number !== 'string') {
      if (!isFromInit) {
        this.errorModal('Invalid Input', 'Phone number is required and must be a string.');
      }
      return;
    }
    let userPhone = number.replace(/\D/g, '');

    if (userPhone.length > 10) {
      userPhone = userPhone.slice(-10);
    }

    if (userPhone.length !== 10) {
      if (!isFromInit) {
        this.errorModal('Invalid Number', 'Phone number must have exactly 10 digits.');
      }
      return;
    }

    this.organizationService.getSuspectDetailByPhoneNumber(userPhone).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          this.suspectDetails = response;
          this.number = userPhone;
          const data = response[0];
          if (state) {
            this.openDetailsModal('POI Info', this.userInfo, data, true);
          }
        } else {
          if (!isFromInit) {
            this.errorModal('No Data Found', 'No suspect details available for this number.');
          }
        }
      },
      error: (error) => {
        console.error('Error fetching suspect details:', error);
        if (!isFromInit) {
          this.errorModal('API Error', 'An error occurred while fetching suspect details.');
        }
      }
    });
  }


  private openDetailsModal(
    title: string,
    data: any,
    suspectDetails: any = null,
    shouldCallApi: boolean
  ) {
    const modalRef = this.modalService.open(DetailsModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top',
      keyboard: false,
    });


    modalRef.componentInstance.title = title;
    modalRef.componentInstance.suspectData = suspectDetails;
    modalRef.componentInstance.showCancel = false;
    modalRef.componentInstance.userInfo = this.userInfo;
    modalRef.componentInstance.shouldCallApi = shouldCallApi;
    return modalRef.result;
  }
  private errorModal(title: string, data: any, showCancel: boolean = false) {
    const modalRef = this.modalService.open(DetailsModalComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top',
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = data;
    modalRef.componentInstance.showCancel = showCancel;

    return modalRef.result;
  }

  sopDetails(details: string, status: boolean) {

    if (!details) {
      return;
    }
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top',
    });
    modalRef.componentInstance.status = status;
    modalRef.componentInstance.message = details;
    modalRef.componentInstance.showCancel = false;
    return modalRef.result;
  }
  dismissAlert(alertId: string): void {
    if (!alertId) {
      console.error('Alert ID is required to dismiss an alert.');
      return;
    }
    this.organizationService.dismissAlert(alertId).subscribe({
      next: (response) => {
        this.alertService.removeAlertIconFromMap(alertId);
        this.activeModal.close('Alert dismissed');
      },
      error: (error) => {
        this.errorModal('Dismiss Alert Error', 'An error occurred while dismissing the alert.');
      }
    });
  }

  private extractErrorMessage(error: any): string {
    try {
      // Try message paths in priority order
      const msg =
        error?.error?.error?.message ||
        error?.error?.message ||
        error?.message ||
        (typeof error === 'string' ? error : null);

      if (typeof msg === 'string' && msg.trim()) {
        return msg.trim();
      }

      // Fallback using error code
      if (error?.error?.code) {
        return `Error: ${error.error.code}`;
      }

    } catch (e) {
      console.error('Error extracting error message:', e);
    }

    return 'Failed to create incident. Please try again.';
  }

   private showAlert(message: string) {
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top'
    });
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.showCancel = false;
    return modalRef.result;
  }

}




